import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import router from '../../router';
import '@pages/newtab/index.css';
import '@assets/styles/tailwind.css';

// 延迟初始化Sentry，避免阻塞首屏渲染
const initSentry = async () => {
  try {
    const { init } = await import("@sentry/react");
    init({
      dsn: "https://de3cc88feafa6e48308b5d8eb8718ec4@o303534.ingest.us.sentry.io/4509021488545792",
      // 降低采样率以减少性能影响
      tracesSampleRate: 0.1,
      // 只在生产环境启用
      enabled: process.env.NODE_ENV === 'production'
    });
  } catch (error) {
    console.warn('Failed to initialize Sentry:', error);
  }
};

function init() {
  const rootContainer = document.querySelector("#__root");
  if (!rootContainer) throw new Error("Can't find root element");
  const root = createRoot(rootContainer);
  root.render(
    <RouterProvider router={router} />
  );
  
  // 使用requestIdleCallback替代setTimeout延迟初始化Sentry
  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(() => initSentry(), { timeout: 3000 });
  } else {
    // 回退到setTimeout
    setTimeout(initSentry, 2000);
  }
}

init();